

































import Vue from 'vue'
import { DeresmaGaineForm } from "@/models/SeismicForm"

import SimpleChooser from "@/components/DeresmaGaine/SimpleChooser.vue"
import StrictChooser from "@/components/DeresmaGaine/StrictChooser.vue"
import Input from '@/components/ui/Input.vue'
import PointsParticuliers from "@/components/SeismicInsepctionForm/_PointsParticuliers.vue"

export default Vue.extend({
  components: {
    PointsParticuliers,
    Input,
    StrictChooser,
    SimpleChooser
  },
  props: {
    form: {
      type: DeresmaGaineForm,
      required: true
    }
  }
})
